import React from 'react';

const AutoWidthModal = ({ id, children, headerText }) => (
  <div className="modal fade" id={id} tabIndex="-1" role="dialog" aria-hidden="true">
    <div className="modal-dialog" style={{width: 'auto'}} >
      <div className="modal-content">
        <div className="modal-message">
          <h3>{headerText}</h3>
          {children}
        </div>
      </div>
    </div>
  </div>
);

export default AutoWidthModal;



// WEBPACK FOOTER //
// ./src/components/common/modals/autoWidthModal.js